
import { useEffect, useState } from 'react';

export default function Footer() {
  const [decodedEmail, setDecodedEmail] = useState('');

  useEffect(() => {
    // JavaScript encoding to hide email from bots
    const encoded = 'aW5mb0Bzbm93aW4uZmk='; // Base64 encoded email
    const decoded = atob(encoded);
    setDecodedEmail(decoded);
  }, []);

  const handleEmailClick = () => {
    if (decodedEmail) {
      window.location.href = `mailto:${decodedEmail}`;
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-teal-900 to-pink-900 text-white relative overflow-hidden">
      {/* Modernist geometric background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="grid grid-cols-8 h-full">
          {Array.from({ length: 32 }).map((_, i) => (
            <div 
              key={i} 
              className={`${i % 3 === 0 ? 'bg-pink-400' : ''} ${i % 5 === 0 ? 'bg-teal-400' : ''} transform ${i % 2 === 0 ? 'rotate-12' : '-rotate-12'}`}
            ></div>
          ))}
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/baffbf7ed36148db6e0b9d29f08b4289/fd6365cb7679f9148b7e4a1f1157e429.png" 
                  alt="SNOWIN Logo" 
                  className="h-16 w-auto"
                />
                <img 
                  src="https://static.readdy.ai/image/baffbf7ed36148db6e0b9d29f08b4289/b4ae1e6213aa7e27a50183c4aee58a1b.png" 
                  alt="Café Snow Logo" 
                  className="h-16 w-auto"
                />
              </div>
              <div>
                <p className="text-xs text-teal-300 font-medium tracking-wide">MODERNIST HERITAGE • EST. 1950s</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
              Welcome to a place unlike any other in Rovaniemi! We've captured the magic of a Finnish winter inside a stunning 1950s architectural masterpiece, blending timeless design with playful Frosty hospitality.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-pink-300">Heritage Experience</h4>
            <ul className="space-y-3">
              <li><a href="#workshops" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer flex items-center"><i className="ri-snowflake-line mr-2 text-teal-400"></i>Snow Sculpting</a></li>
              <li><a href="#cafe" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer flex items-center"><i className="ri-cup-line mr-2 text-teal-400"></i>Modernist Café</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-pink-300 transition-colors cursor-pointer flex items-center"><i className="ri-heart-line mr-2 text-teal-400"></i>Frosty Hospitality</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-300">Step into a Piece of Finnish History</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-pink-400 mt-1"></i>
                <div>
                  <div className="font-medium">The Old Rovaniemi Bus Station (Rovaniemen Linja-autoasema), a 1950s modernist landmark.</div>
                  <div className="text-sm text-gray-400">Lapinkävijäntie 2, Rovaniemi</div>
                </div>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-pink-400"></i>
                <span>+358 44 766 9990</span>
              </li>
              <li className="flex items-center space-x-2 cursor-pointer hover:text-white transition-colors" onClick={handleEmailClick}>
                <i className="ri-mail-line text-pink-400"></i>
                <span>{decodedEmail || 'Loading...'}</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-time-line text-pink-400"></i>
                <span>Daily 8:00 - 20:00</span>
              </li>
            </ul>
          </div>
          
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left mb-4 md:mb-0">
              <p className="text-gray-400 text-sm mb-1">
                © 2025 SNOWIN - Unleash Your Inner Frosty Artist
              </p>
              <p className="text-xs text-gray-500">
                Preserving Scandinavian architectural legacy since the 1950s
              </p>
              <div className="flex flex-wrap gap-4 mt-2">
                <a href="/privacy-policy" className="text-xs text-gray-400 hover:text-pink-300 transition-colors cursor-pointer">
                  Privacy Policy
                </a>
                <a href="/terms-conditions" className="text-xs text-gray-400 hover:text-pink-300 transition-colors cursor-pointer">
                  Terms & Conditions
                </a>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </footer>
  );
}
